/* name */
var RE_WRONG_CHARACTER = /[\d\*\^<>\\";:\[\]!@#\.]/,
    RE_THREE_SAME_CHARACTERS_CONSEQUENTLY = /(.)\1\1/i,
    RE_SEVEN_CONSONANTS_CONSEQUENTLY = /[bcdfghjklmnpqrstvwxz]{7,}/i,
    RE_VOWEL = /[aeiouy]/i;
/* email */
var RE_TWO_AT_SIGNS = /@.*@/,
    RE_HANDLER_HAS_NO_WRONG_CHARACTERS = /^[^\*\^<>\\";:\[\]!@#]+@/,
    RE_DOMAIN_HAS_NO_WRONG_CHARACTERS = /@[^\*\^<>\\";:\[\]!@#]+$/,
    RE_DOMAIN_HAS_PERIOD = /@([^\.]+\.)+[^\.]+$/;
/* phoneNumber */
var RE_TEN_DIGITS = /^\d{10}$/,
    RE_SEVEN_SAME_LAST_DIGITS = /(\d)\1{6}$/,
    RE_STARTS_NOT_WITH_01 = /^[^01]/,
    RE_WRONG_AREA_CODE = /^(222|333|411|444|456|500|555|666|777|911|900|999)/,
    RE_WRONG_PREFIX = /^\d{3}(411|555|611|911)/,
    TEN_NUMBER_PHONE_WITH_DASHES_BRACKETS = [
        /^\d{3}\s\d{3}\s\d{4}$/,
        /^\d{3}\s\d{3}-\d{4}$/,
        /^\d{3}-\d{3}-\d{4}$/,
        /^\(\d{3}\)\s\d{7}$/,
        /^\(\d{3}\)\s\d{3}-\d{4}$/,
        /^\(\d{3}\)\d{3}-\d{4}$/

    ],
    ELEVEN_NUMBER_PHONE_WITH_DASHES_BRACKETS = [
        /^1\d{10}$/,
        /^1-\d{3}-\d{3}-\d{4}$/,
        /^1\s\d{3}\s\d{3}\s\d{4}$/
    ];
/* zipCode */
var RE_FIVE_DIGITS = /^\d{5}$/;

function validateName(name) {
    if (!name) {
        return false;
    }
    name = name.trim();
    return name.length > 1 &&
        !RE_WRONG_CHARACTER.test(name) &&
        !RE_THREE_SAME_CHARACTERS_CONSEQUENTLY.test(name) &&
        !RE_SEVEN_CONSONANTS_CONSEQUENTLY.test(name) &&
        RE_VOWEL.test(name);
}

function validateEmail(email) {
    if (!email) {
        return false;
    }
    email = email.trim();
    return !RE_TWO_AT_SIGNS.test(email) &&
        RE_HANDLER_HAS_NO_WRONG_CHARACTERS.test(email) &&
        RE_DOMAIN_HAS_NO_WRONG_CHARACTERS.test(email) &&
        RE_DOMAIN_HAS_PERIOD.test(email);
}

function validatePhoneNumber(phone) {
    if (!phone) {
        return false;
    }
    phone = phone.trim();
    phone = getPhoneNumbers(phone); //use for case where we have dashes, brackets or start with 1
    return RE_TEN_DIGITS.test(phone) &&
        !RE_SEVEN_SAME_LAST_DIGITS.test(phone) &&
        RE_STARTS_NOT_WITH_01.test(phone) &&
        !RE_WRONG_AREA_CODE.test(phone) &&
        !RE_WRONG_PREFIX.test(phone);
}

function validateZipCode(zipCode) {
    if (!zipCode) {
        return false;
    }

    return RE_FIVE_DIGITS.test(zipCode);
}

function getPhoneNumbers (phone) {
    var hasElevenNumber = ELEVEN_NUMBER_PHONE_WITH_DASHES_BRACKETS.some(function (item) {
        return item.test(phone);
    });
    var hasTenNumber = TEN_NUMBER_PHONE_WITH_DASHES_BRACKETS.some(function (item) {
        return item.test(phone);
    });
    if(hasElevenNumber || hasTenNumber) {
        return getNumberWithoutDashes(phone, hasElevenNumber);
    }
    return phone;
}

function getNumberWithoutDashes (phone, hasElevenNumber) {
    var phoneNumbers = '';
    var currentPhoneSymbols = phone.split('');
    if(hasElevenNumber) {
        currentPhoneSymbols = currentPhoneSymbols.slice(1);
    }
    currentPhoneSymbols.forEach(function (symbol) {
        if(/\d/.test(symbol)) {
            phoneNumbers += symbol;
        }
    });
    return phoneNumbers;
}

function validateMinLength(field, minLength) {
    return field ? (field.length > minLength) : false;
}

module.exports = {
    getPhoneNumbers: getPhoneNumbers,
    validateName: validateName,
    validateEmail: validateEmail,
    validatePhoneNumber: validatePhoneNumber,
    validateZipCode: validateZipCode,
    validateMinLength: validateMinLength
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/validation/common/basic.js
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 16 19 21 24 25